import { render, staticRenderFns } from "./Slu.vue?vue&type=template&id=01ffd183&scoped=true&"
var script = {}
import style0 from "./Slu.vue?vue&type=style&index=0&id=01ffd183&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ffd183",
  null
  
)

export default component.exports